
import CheckRadioMixin from '@oruga-ui/oruga/src/utils/CheckRadioMixin'

export default {
  name: 'NeoRadioButton',
  mixins: [CheckRadioMixin],
  props: {
    type: {
      type: String,
      default: 'is-primary',
    },
    expanded: Boolean,
    rounded: Boolean,
  },
  data() {
    return {
      isFocused: false,
    }
  },
  computed: {
    isSelected() {
      return this.newValue === this.nativeValue
    },
    labelClass() {
      return [
        this.isSelected ? this.type : null,
        this.size,
        {
          'is-selected': this.isSelected,
          'is-disabled': this.disabled,
          'is-focused': this.isFocused,
          'is-loading': this.loading,
          'is-rounded': this.rounded,
        },
      ]
    },
  },
}
